
$('.home_coll').slick({
  dots: false,
  infinite: false,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0923/1948/2194/files/right-arrow_1_2.png?v=1761309428'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0923/1948/2194/files/right-arrow_1_1.png?v=1761309428'></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});




$('.reviewww').slick({
  dots: false,
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0923/1948/2194/files/right-arrow_1_2.png?v=1761309428'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0923/1948/2194/files/right-arrow_1_1.png?v=1761309428'></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$('.colors_slider').slick({
  infinite: true,
  speed: 300,
  arrows:false,
  dots:false,
  autoplay: true,
  autoplaySpeed: 2000,
  centerMode: true,
  centerPadding: '60px',
  slidesToScroll: 4,
  slidesToShow: 9,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '60px',
        slidesToShow: 4
      }
    },
     {
      breakpoint: 989,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 3
      }
    },
    {
      breakpoint: 749,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '10px',
        slidesToShow: 2
      }
    }
  ]
});



   $(document).ready(function() {
    $("[data-fancybox='gallery']").fancybox({
        thumbs: {
            autoStart: true
        },
        buttons: [
            "zoom",
            "slideShow",
            "thumbs",
            "close"
        ],
        transitionEffect: "slide",  // Animation type: "fade", "slide", "zoom-in-out", "circular", etc.
        transitionDuration: 500     // Duration of the animation in milliseconds
    });
});





 $(".gallery231").slick({
    speed: 7000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
    arrows:false,
    slidesToShow: 3,
  	slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
  	centerMode: true,
    focusOnSelect: true,
    responsive: [
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
              }
            }
            ]
});


  function switchTab(ind,url,sectionId){
  let link = document.querySelector(`.see_all_link_${sectionId}`);

  if (link) {
    link.href = url;
  }
  let tabSwitch = document.querySelector(`.tab_switch${ind}_${sectionId}`);
  let removeHidden = document.querySelector(`.cotain_bls_${ind}_${sectionId}`);
  let collBtns = document.querySelectorAll(`.coll_btn_${sectionId}`);
  let hidden = document.querySelectorAll(`.swiper_container_${sectionId}`);
  collBtns.forEach(btn => {
    btn.classList.remove('active');
  });
  hidden.forEach(hiddenClass => {
    hiddenClass.classList.add('hidden');
  });
  removeHidden.classList.remove('hidden');
  tabSwitch.classList.add('active');
  }



$('.myslider').slick({

slidesToScroll: 1,
arrows: false,
autoplay: true,
autoplaySpeed: 4000,
dots: false,
vertical: true,
verticalSwiping: true
    
});



$('.hom-img-txtt').slick({
slidesToScroll: 1,
arrows: false,
infinite: true,
autoplay: true,
autoplaySpeed: 2000,
dots: false  
});




 let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });




function addToCart(id){
let formData = {
                               id: id,
                               quantity: 1,
                  };
                $.ajax({
                   url: '/cart/add',
                   type: 'POST',
                   data: formData,
                  success: function(response){
                    $.ajax({
                      url: '/?section_id=cart-drawer',
                      type: 'GET',
                      dataType: 'html',
                      success: function(carthtml){
                        window.aovCartDrawerUpdateAndOpen()
                         $('.drawer').addClass('animate active');
                         $('cart-drawer').html($(carthtml).find('cart-drawer').html());
                         bubbleUpdate();
                         $('cart-drawer').removeClass('is-empty');
                      }
                    })
                  }
                });
                function bubbleUpdate() {
                      fetch(window.Shopify.routes.root + 'cart.js')
                             .then(response => response.json())
                             .then(data => {
                                  $('.cart-count-bubble').text(data.item_count);
                               });
                       }
              }




              
$('.mscscscss').slick({
  infinite: true,
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  slidesToShow: 1,
  slidesToScroll: 1
});



  document.addEventListener('DOMContentLoaded', function() {
    function initMobileSlider() {
      var $slider = jQuery('.custom_collection_banners');

      if (window.innerWidth <= 989) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 2,
            responsive: [
          {
            breakpoint: 749,   // below 480px
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          }
        ]
          });
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }
      }
    }

    initMobileSlider();
    window.addEventListener('resize', initMobileSlider);
  });

